import { analyticsReady } from '@galapagos/observability';
import { clearWebAnalyticsIdentity } from '@/app/analytics';
import { clearFeatureFlagSnapshot } from '@/features/feature-flags';
import { clearSessionTokens, hasSession } from '@/services/session';

/**
 * Ends a sign-in an earlier member left in this tab, as a new signup link
 * loads. Their credentials would otherwise ride along on the new member's
 * code check, so a wrong code would end that old session and restart the
 * flow; their analytics identity and the flags evaluated for them would
 * label the new member's visit as theirs. Clearing the flag values also
 * retires an identification still in flight. The employer SSO session and the
 * landing's attribution belong to the new link, so they stay. A tab with no
 * sign-in keeps its anonymous analytics identity, so a landing visit carries
 * straight on into signup.
 */
export function endLeftoverSession(): void {
  if (!hasSession()) return;
  clearSessionTokens();
  clearFeatureFlagSnapshot();
  // Asked one turn later, as the analytics helpers do: this runs from the
  // entry's first effect, which can come before the root provider's effect
  // starts init, and the provider installed then is the one holding the
  // earlier member's identity.
  void Promise.resolve()
    .then(() => analyticsReady())
    .then(
      () => {
        // A new member who signed in meanwhile keeps their own identity.
        if (!hasSession()) clearWebAnalyticsIdentity();
      },
      () => {},
    );
}
